<template>
    <v-container>
        <v-row class="contentRow">
            <v-col>
            <v-form ref="form" v-model="valid"  lazy-validation>
                <h1 class="mb-2">{{title}} Transaction</h1>
                <v-banner
                        style="border-bottom: hidden !important;"
                        class="rounded my-1"
                        color="grey lighten-2"
                        light
                        v-if="action==='replace'"
                >
                    <v-row class="ml-1" >
                        <h4 class="ml-1">Note:</h4>
                        <span>
                            Editing will invalidate transaction
                            <strong>
                            <router-link :to="`/trace/transactions/${transactionID}`" style="color: inherit;text-decoration: none"> #{{transactionID}}</router-link>
                            </strong>
                            and replace it with a new transaction!
                        </span>
                    </v-row>
                </v-banner>
                <v-banner
                        style="border-bottom: hidden !important;"
                        class="rounded my-1"
                        color="grey lighten-2"
                        light
                        v-if="action==='clone'"
                >
                    <v-row class="ml-1" >
                        <h4 class="ml-1">Note:</h4>
                        <span>
                            Cloning will create a new transaction filled with data from transaction #{{transactionID}}. You may change any of the fields.
                        </span>
                    </v-row>
                </v-banner>
                <v-col >
                    <v-btn class="my-2" color="secondary" small outlined @click="showHint=!showHint">
                        <v-icon left small>fa-question-circle</v-icon>
                        Show / Hide
                    </v-btn>
                </v-col>
            <div v-for="(field) in fields" v-bind:key="field.Name">
                <div v-if="field.Type!=='computed' && field.Name !== 'PreviousTransaction'">
                    <h3 color="secondary">
                        <v-icon v-if="field.Required" color="error"  left x-small>fa-asterisk</v-icon>
                        <v-icon v-if="field.Immutable" left color="primary" small>fas fa-lock</v-icon>
                        {{field.DisplayName}}
                    </h3>
                    <p v-if="showHint" class="mt-1 text-left font-italic">{{field.Hint}}</p>
                    <file-uploader v-model="dataFields[field.Name]" v-if="field.Type.indexOf('file') >= 0"/>
                    <v-text-field
                            v-else-if="field.SuggestedValues===undefined && field.Type!=='computed' && field.Type!=='date'"
                            :label="field.DisplayName"
                            v-model="dataFields[field.Name]"
                            :value="dataFields[field.Name]"
                            :placeholder="field.DisplayName"
                            :rules="field.ValidationRules"
                            :type="field.Type"
                            outlined
                            dense
                    >
                        <template v-slot:append v-if="field.Name==='Recipient'">
                            <v-btn
                                    height="40px"
                                    style="margin-top: -8px;margin-right: -12px"
                                    align="center"
                                    color="primary"
                                    @click="dialog=true"
                                    >
                              Select from  Address Book
                            </v-btn>
                        </template>
                    </v-text-field>
                    <v-combobox
                            v-else-if="field.SuggestedValues!==undefined "
                            @change="(v)=>dataFields[field.Name]=htmlDecode(v)"
                            :label="field.DisplayName"
                            :value="dataFields[field.Name]"
                            :items="field.SuggestedValues"
                            :rules="field.ValidationRules"
                            outlined
                            dense
                            return-object
                    >
                        <template slot='selection' slot-scope='{ item }'>
                            {{htmlDecode(item)}}
                        </template>
                        <template slot='item' slot-scope='{ item }'>
                            {{htmlDecode(item)}}
                        </template>
                    </v-combobox>
<!--                    Date Picker-->
                    <v-menu
                            v-else-if="field.Type==='date'"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    :value="dataFields[field.Name]"
                                    v-model="dataFields[field.Name]"
                                    :label="field.DisplayName"
                                    :rules="field.ValidationRules"
                                    :placeholder="field.DisplayName"
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                            ></v-text-field>
                        </template>
                        <v-date-picker
                                @input="menu2 = false"
                                :label="field.DisplayName"
                                @change="(v)=>dataFields[field.Name]=formatDate(v)"
                                :value="changeDateFormat(dataFields[field.Name])"
                                :rules="field.ValidationRules"
                                color="primary"

                        ></v-date-picker>
                    </v-menu>
            </div>
            </div>
            <v-row>
                <v-col >
                    <v-btn color="success"  align="center" class="mt-4" @click="saveDraft"   style="margin:5px">
                        Save as draft
                    </v-btn>
                    <v-btn color="primary"  align="center" class="mt-4" @click="addTransaction" :disabled="!valid" style="margin:5px">
                        {{title}} transaction
                    </v-btn>
                </v-col>
            </v-row>
                </v-form>
            </v-col>
        </v-row>
<!--        Address Book Modal-->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>Address book</v-card-title>
                <v-data-table
                        align="center"
                        :loading="!connections"
                        theme--
                        light
                        :headers="headers"
                        :items="connections"
                        :items-per-page="20"
                        class="light table"
						:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                >
                    <template v-slot:item.select="{ item }">
                        <v-btn color="primary" v-on:click="selectRecipient(item.clientID)">
                           Select
                        </v-btn>
                    </template>
                </v-data-table>
                <v-card-actions>
                    <v-btn color="error" text v-on:click="dialog = false" outlined>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import PresetAPI from "../api/trace/presets"
import TransactionAPI from "../api/trace/transaction"
import DraftAPI from "../api/trace/draft"
import LoadingState from "../consts/LoadingState"
import { mapState } from "vuex"
import router from "../router"
import ConnectionAPI from "../api/connections/connection"
import FileUploaderVue from "./FileUploader.vue"
export default {
	name: "TransactionInput",
	components: {
		"file-uploader": FileUploaderVue
	},
	props:{
		action:String,
		transactionID:Number,
		draftID:Number,
	},
	data() {
		return {
			fields:null,
			dataFields: null,
			valid:true,
			dialog:false,
			connections:null,
			showHint:true,
			title:null,
			selectedPreset: 0, 
			files: {},
			headers: [
				{ text: "Client ID", value: "clientID", sortable: false },
				{ text: "Name", value: "name", sortable: false },
				{ text: "Select", value: "select", sortable: false }
			],
		}
	},
	mounted() {
		if (this.$route.query.preset) {
			this.selectedPreset = this.$route.query.preset
		}
		this.getPresets()
		this.loadConnections()
		switch (this.action) {
		case "replace":
			this.title="Edit"
			this.getTransaction()
			break
		case "clone":
			this.title="Clone"
			this.getTransaction()
			break
		case "forward":
			this.dataFields["PreviousTransaction"] = this.transactionID
			break
		default:
			this.title="Add"
		}
	},
	methods: {
		htmlDecode(input) {
			let doc = new DOMParser().parseFromString(input, "text/html")
			return doc.documentElement.textContent
		},
		loadConnections() {
			// Do not use global loading here — getPresets() already drives the overlay.
			// START without END caused stuck "Loading..." in Trace when connections finished after presets.
			ConnectionAPI.getConnections()
				.then((data) => {
					this.connections = data
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getPresets() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Getting Preset...",
				{ root: true }
			)
			PresetAPI.getPresets(this.selectedPreset)
				.then((data) => {
					let presetFields=data.data
					let arrangedFields=presetFields.map((field)=>(
						{
							...field,
							DisplayName:field.Name.replace(/([a-z])([A-Z])/g, "$1 $2").trim(),
							ValidationRules:[v => (!field.Required || !!v ) || field.Name.replace(/([A-Z])/g, " $1").trim() + " is required",
								v => (v ? !(field.Type.toString() ==="string") || typeof v==="string":true) || field.Name.replace(/([a-z])([A-Z])/g, "$1 $2").trim() + " must be a " +field.Type,
								v=> (v ? !(field.Type.toString() ==="integer") || /^[-+]?\d+$/.test(v):true) || field.Name.replace(/([a-z])([A-Z])/g, "$1 $2").trim() + " must be a "+  field.Type
							],
						}
					))
					this.fields=arrangedFields
					let fieldData  ={}
					presetFields.map((field)=>
						fieldData[field.Name]=undefined
					)
					this.dataFields=fieldData

					if(this.draftID){
						this.getDrafts()
					}
					if(this.transactionID){
						this.getTransaction()
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getTransaction(){
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Getting Transaction...",
				{ root: true }
			)
			TransactionAPI.getTransaction(this.transactionID)
				.then((data) => {
					let values=data.data
					let arr  = [],
						keys = Object.keys(values)
					for(let i=0,n=keys.length;i<n;i++){
						let key  = keys[i]
						arr[key] = values[key]?.value
					}

					let dataField={...arr,Recipient:data?.Recipient?.id }
					this.dataFields=dataField
					this.validateForm()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getDrafts(){
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Loading...",
				{ root: true }
			)
			DraftAPI.getDrafts(this.draftID)
				.then((data) => {
					let values=data[0].attr
					let arr  = [],
						keys = Object.keys(values)

					for(let i=0,n=keys.length;i<n;i++){
						let key  = keys[i]
						arr[key] = values[key]?.value
					}
					let dataField={...arr}
					this.dataFields=dataField
					this.validateForm()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		resetForm() {
			this.$refs.form.reset()
		},
		validateForm() {
			this.$refs.form.validate()
		},
		changeDateFormat(date){
			return  date?.split("/")?.reverse()?.join("-")
		},
		formatDate (date) {
			if (!date) return null
			const [year, month, day] = date.split("-")
			return `${day}/${month}/${year}`
		},
		selectRecipient(clientID){
			this.dataFields.Recipient=clientID
			this.dialog=false
		},
		addTransaction(){
			this.validateForm()
			if(this.valid){
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					"Adding Transaction...",
					{ root: true }
				)
				if(this.transactionID && this.action==="replace"){
					TransactionAPI.editTransaction({...this.dataFields,preset:this.selectedPreset,ReplacingTransaction:this.transactionID})
						.then((data) => {
							if(this.draftID){
								this.deleteDraft()
							}
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
								"Transaction was successfully added!",
								{ root: true }
							)
							router.push(`/trace/transactions/${data}`)
						})
						.catch(reason => {
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_SET_ERROR,
								reason,
								{ root: true }
							)
						})
				}else{
					TransactionAPI.addTransaction({...this.dataFields,preset:this.selectedPreset})
						.then((data) => {
							if(this.draftID){
								this.deleteDraft()
							}
							this.resetForm()
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
								"Transaction was successfully added!",
								{ root: true }
							)
							router.push(`/trace/transactions/${data}`)
						})
						.catch(reason => {
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_SET_ERROR,
								reason,
								{ root: true }
							)
						})
						.finally(() => {
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_END_LOADING,
								null,
								{ root: true }
							)
						})
				}
			}
		},
		saveDraft(){
			this.validateForm() 
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Saving Draft...",
				{ root: true }
			)
			if(this.draftID ){
				DraftAPI.editDraft(this.draftID,{data:this.dataFields,preset:this.selectedPreset})
					.then(() => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
							"Draft was successfully updated!",
							{ root: true }
						)
					})
					.catch(reason => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							reason,
							{ root: true }
						)
					})
					.finally(() => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							null,
							{ root: true }
						)
					})
			}else{
				DraftAPI.addDraft({data:this.dataFields,preset:this.selectedPreset})
					.then((data) => {
						this.resetForm()
						router.push({name: "Draft Details", params: {id: data.id}})
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
							"Draft was successfully added!",
							{ root: true }
						)
					})
					.catch(reason => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							reason,
							{ root: true }
						)
					})
			}
		},
		deleteDraft(){
			DraftAPI.deleteDraft(this.draftID)
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
	},
	computed: {
		...mapState("loading", {
			loading: (state) => state.loading == LoadingState.LOADING,
		}),
	},
}
</script>